import { render } from "./QuickpayPaymentFeedback.vue?vue&type=template&id=af01dcaa&scoped=true"
import script from "./QuickpayPaymentFeedback.vue?vue&type=script&lang=js"
export * from "./QuickpayPaymentFeedback.vue?vue&type=script&lang=js"

import "./QuickpayPaymentFeedback.vue?vue&type=style&index=0&id=af01dcaa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af01dcaa"]])

export default __exports__